angular.module('unica_media_directory.media_directory_services')

.factory('MediaDirectoryCreateService', function ($http, getBaseApiURL) {

	var mediaDirectoryCreateService = {};

	mediaDirectoryCreateService.create = function ( mediaDirectoryData ) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/media-directory/create',
			data: mediaDirectoryData
		}).then(function(result) {

			if ( result ) {
				return result.data.directory;
			}

		});
 
	};

	mediaDirectoryCreateService.createArchive = function ( mediaDirectoryData ) {

		mediaDirectoryData.archive = 1;

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/media-directory/create-archive',
			data: mediaDirectoryData
		}).then(function(result) {

			if ( result ) {
				return result.data.directory;
			}

		});
 
	};

	return mediaDirectoryCreateService;
});